
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
declare global {
    interface Window {
        OneSignal: any;
        OneSignalDeferred: any;
    }
}
@Injectable({
    providedIn: 'root',
})
export class OneSignalService {
    isMobile  = false;
    constructor(private deviceService: DeviceDetectorService) {
        this.isMobile = this.deviceService.isMobile();
      //  if(!this.isMobile) this.initializeOneSignal();
    }

    initializeOneSignal() {
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        const currentUserId = (currentUser && currentUser.id) ?  currentUser.id + "_drafters" :"";
        window.OneSignalDeferred = window.OneSignalDeferred || [];
        window.OneSignalDeferred.push(async function (OneSignal) {
            await OneSignal.init({
                appId: environment.ONE_SIGNAL_APP_ID,
                safari_web_id: environment.REST_API_KEY,
                notifyButton: {
                    enable: true,
                    position: 'bottom-left',
                    theme: 'default'
                },
            }); 
            OneSignal.User.addTag('user_ids', currentUserId);
        });
    }
}